// src/features/nc/routes.ts
import { lazy } from 'react';
import { AlertTriangle } from 'lucide-react';
import { RouteConfig } from '../../types/routing.types';

const NcDashboard = lazy(() => import('./NcDashboard'));
const NcDetailPage = lazy(() => import('./components/NcDetailPage'));
const NcCreateForm = lazy(() => import('./components/NcCreateForm'));
const NcCockpit = lazy(() => import('./components/NcCockpit'));
const NcStatistiques = lazy(() => import('./components/NcStatistiques'));

export const ncRoutes: RouteConfig[] = [
  {
    path: '/nc',
    component: NcDashboard,
    label: 'Non-Conformites',
    icon: AlertTriangle,
    showInNav: true,
    navPath: '/nc',
    breadcrumb: ['Accueil', 'Non-Conformites'],
  },
  {
    path: '/nc/new',
    component: NcCreateForm,
    label: 'Nouvelle NC',
    showInNav: false,
    breadcrumb: ['Accueil', 'Non-Conformites', 'Nouvelle NC'],
  },
  {
    path: '/nc/cockpit',
    component: NcCockpit,
    label: 'Cockpit NC',
    showInNav: false,
    breadcrumb: ['Accueil', 'Non-Conformites', 'Cockpit'],
  },
  {
    path: '/nc/statistiques',
    component: NcStatistiques,
    label: 'Statistiques NC',
    showInNav: false,
    breadcrumb: ['Accueil', 'Non-Conformites', 'Statistiques'],
  },
  {
    path: '/nc/:id',
    component: NcDetailPage,
    label: 'Detail NC',
    showInNav: false,
    breadcrumb: ['Accueil', 'Non-Conformites', 'Detail'],
  },
];
